module.exports = __webpack_public_path__ + "static/img/new5-BXePd3Zp.d5629d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/new5-BXePd3Zp.png
// module id = cpMI
// module chunks = 16